import styled, { keyframes } from 'styled-components';
import colors from '../../UI/Colors/index';

const pulso = keyframes`
    0% {transform: scale(1);}
    50% {transform: scale(1.2);}
    100% {transform: scale(1);}
    `;

export const Container = styled.section`
  //margin-top: 1px;
  padding: 100px 60px;
  background: ${colors.gray_primary};
  @media (max-width: 1000px) {
    padding: 80px 30px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 100vw;
  margin: 0 auto;
  //background: blue;
`;

export const ColumnLeft = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  //animation: ${pulso} 5s linear infinite;
  //background: red;
  padding-bottom: 32px;
  @media (max-width: 600px) {
    width: 100%;
    margin-left: 0px;
  }
`;

export const Description = styled.h2`
  font-family: Muli;
  font-style: normal;
  font-weight: bold;
  font-size: 54px;
  line-height: 110%;
  text-align: left;
  color: #333333;
  padding-left: 30px;
  padding-top: 30px;
  @media (max-width: 800px) {
    font-size: 44px;
  }
  @media (max-width: 600px) {
    font-size: 34px;
    padding-left: 15px;
    padding-top: 0px;
  }
`;

export const Row = styled.div`
  //background: pink;
  display: grid;
  grid-template-columns: 30vw 54vw;
  grid-gap: 35px;
  padding-left: 40px;
  @media (max-width: 1000px) {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
  @media (max-width: 600px) {
    padding-left: 0px;
  }
`;

export const Link = styled.a`
  width: 233px;
  height: 45px;

  background: #1e88e5;
  border-radius: 15px;
  font-family: Mulish;
  font-style: normal;
  font-weight: 600;
  font-size: 25px;
  line-height: 149.3%;
  color: #ffffff;
  padding-top: 5px;
  margin-top: 15px;
  margin-left: 30px;
  text-decoration: none;
 &:hover {
    color: #9b9999;
    background: ${colors.blue_footer}
    transition: 200ms ease-in;
    text-decoration: none;
  }
  @media (max-width: 600px) {
    width: 183px;
    height: 35px;
    padding-top: 1px;
    font-size: 20px;
     margin-left: 15px;
  }
`;

export const TitleSection = styled.h2`
  //margin-bottom: 20px;
  font-family: Muli;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 115%;
  text-align: justify;
  text-transform: uppercase;
  color: #4070ff;
  padding-left: 40px;
  @media (max-width: 600px) {
    padding-left: 10px;
  }
`;

export const Line = styled.div`
  width: 217px;
  height: 6px;
  background: #4070ff;
  border-radius: 10px;
  margin-bottom: 50px;
  margin-left: 40px;
  @media (max-width: 600px) {
    margin-left: 10px;
  }
`;
